import React, { useEffect, useState, useCallback, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getTopics, bookmarkTopic, deleteBookmarkTopic } from "../../services/SatCourseService";
// @ts-ignore
import ApiNames from "../../constants/ApiNames";
import Topics from "../../components/SatCourse/Topics";
// @ts-ignore
import UrlNames from "../../constants/UrlNames";
// @ts-ignore
import UserContext from "../../utils/UserContext";

export interface TopicsScreenProps {
  token?: string;
  loaderStatus?: (status: boolean) => void;
  moduleIndex?: number;
}

const TopicsScreen: React.FC<TopicsScreenProps> = (props) => {
  const { subscriberId, checkRefresh, setActiveIndex, activeIndex } =
    useContext<any>(UserContext);
  const useLocations = useLocation();
  const chaptersId = useLocations.state?.chaptersId;
  const moduleId = useLocations.state?.moduleId;
  const chaptersCurrentIndex = useLocations.state?.index || 0;
  const chaptertitle = useLocations.state?.title || "";
  const progressPercent = parseInt(useLocations.state?.progressPercent || "0");
  const about = useLocations.state?.about || "";
  const moduleIndex = useLocations.state?.moduleIndex;
  const chapterIndex = useLocations.state?.chapterIndex;
  
  const [listData, setListData] = useState<any[]>([]);
  const [isError, setISError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  const topicsApiCall = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await getTopics(chaptersId, subscriberId, props.token);

      if (response && response.status === 200) {
        setListData(response.response);
      } else {
        setISError(response.response as any);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
      if (props.loaderStatus) props.loaderStatus(true);
    }
  }, [chaptersId, props, subscriberId]);

  useEffect(() => {
    topicsApiCall();

    if (!checkRefresh) {
      setActiveIndex(moduleIndex);
    } else if (activeIndex !== props?.moduleIndex) {
      setActiveIndex(moduleIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const HandleBookMark = useCallback(async (id: string | number, index: number) => {
    const data = {
      subscriberId: subscriberId,
      topicId: id,
    };
    try {
      const response = await bookmarkTopic(data, props.token);

      if (response && response.status === 200) {
        const newData = [...listData];
        newData[index].isBookmarked = !newData[index].isBookmarked;
        setListData(newData);
      } else {
        console.log("Response", response?.status);
      }
    } catch (error) {
      console.log(error);
    }
  }, [listData, props.token, subscriberId]);

  const HandleDeleteBookMark = useCallback(async (id: string | number, index: number) => {
    const data = {
      subscriberId: subscriberId,
      topicId: id,
    };
    try {
      const response = await deleteBookmarkTopic(data, props.token);

      if (response && response.status === 200) {
        const newData = [...listData];
        newData[index].isBookmarked = !newData[index].isBookmarked;
        setListData(newData);
      } else {
        console.log("Response ", response?.status);
      }
    } catch (error) {
      console.log("FAIL to load");
    }
  }, [listData, props.token, subscriberId]);

  const HandleGoBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const HAndleIndex = useCallback((item: any, index: number) => {
    navigate(UrlNames.content, {
      state: {
        item,
        chapterTitle: chaptertitle,
        chapterIndex: chapterIndex,
        listData: listData,
        index: index,
        chaptersCurrentIndex: chaptersCurrentIndex,
        moduleId: moduleId,
        moduleIndex: moduleIndex,
      },
    });
  }, [chapterIndex, chaptersCurrentIndex, chaptertitle, listData, moduleId, moduleIndex, navigate]);

  return (
    <>
      <Topics
        listData={listData}
        isError={isError}
        HAndleIndex={HAndleIndex}
        chaptertitle={chaptertitle}
        progressPercent={progressPercent}
        about={about}
        HandleBookMark={HandleBookMark}
        HandleDeleteBookMark={HandleDeleteBookMark}
        chaptersCurrentIndex={chaptersCurrentIndex}
        HandleGoBack={HandleGoBack}
        isLoading={isLoading}
      />
    </>
  );
};
export default TopicsScreen;
